export default "__VITE_ASSET__75dc8b7f__"